import { GetBidDetail } from "@/services/Bid";
import { useEffect, useState } from "react";

type BudgetMap = Record<
  string,
  { budget: number; basisAmount: string | undefined }
>;

export function useBudgetAmountMap(projectIds: string[]) {
  const [budgetMap, setBudgetMap] = useState<BudgetMap>({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const uniqueIds = Array.from(new Set(projectIds.filter(Boolean)));

    if (uniqueIds.length === 0) return;

    setIsLoading(true);
    Promise.all(
      uniqueIds.map(async (projectId) => {
        try {
          const res = await GetBidDetail(projectId);
          const budget = res.data.pods[0].content.items[0].budget_amount ?? 0;
          const basisAmount = res.data.pods[0].content.items[0].basis_amount;
          return {
            projectId,
            budget: Number(budget),
            basisAmount: basisAmount ?? undefined,
          };
        } catch {
          return { projectId, budget: 0, basisAmount: undefined };
        }
      })
    )
      .then((results) => {
        const map: BudgetMap = {};
        results.forEach(({ projectId, budget, basisAmount }) => {
          map[projectId] = { budget, basisAmount };
        });
        setBudgetMap(map);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [projectIds.join(",")]);

  return { budgetMap, isLoading };
}
